import { computed, reactive } from 'vue'

const searchQueryState = reactive({
  take: 8,
  page: 1,
  terms: [],
  searchType: null,
  searchTypes: [],
  sorting: null,
  view: null,
  activeCategories: [],
  language: null,

  updated: Date.now(),
  initialized: false
})

export default {
  searchQueryUse(routeData) {
    const state = searchQueryState

    const activeTermsAndFilters = computed(() => {
      const filters = state.activeCategories.map((name) => {
        const type = 'filter'
        return {
          name,
          type
        }
      })
      const terms = state.terms.map((name) => {
        const type = 'term'
        return {
          name,
          type
        }
      })
      return [...filters, ...terms]
    })

    const groupByCategories = computed(() => state.searchType === 'product'
                                          && !activeTermsAndFilters.value?.length)
    const defaultSorting = computed(() => {
      if (state.searchType !== 'product') {
        return null
      }
      return groupByCategories.value ? 'categoryRank' : 'manual'
    })

    const resetLastUpdated = () => {
      state.updated = Date.now()
    }

    if (!state.initialized && routeData) {
      state.activeCategories = routeData.activeCategories || []
      state.searchType = routeData.searchType
      state.terms = routeData.terms || []
      state.sorting = routeData.sorting || defaultSorting
      state.view = routeData.view
      state.initialized = true
      state.language = routeData.language
      resetLastUpdated()
    }

    const setAllSearchTypes = (searchTypes) => {
      state.searchTypes = searchTypes
    }

    const setSearchType = (searchType) => {
      if (state.searchType === searchType) {
        return
      }

      state.searchType = searchType

      state.page = 1
      state.sorting = null
      state.view = null
      state.activeCategories = []

      resetLastUpdated()
    }

    const setSorting = (sorting) => {
      if (state.sorting === sorting) {
        return
      }

      state.sorting = sorting
      resetLastUpdated()
    }

    const setView = (view) => {
      if (state.view === view) {
        return
      }

      state.view = view
    }

    const setActiveCategories = (activeCategories) => {
      state.activeCategories = activeCategories || []
      resetLastUpdated()
    }

    const addCategory = (category) => {
      const index = state.activeCategories
        .map((activeCategory) => activeCategory.slug)
        .indexOf(category.slug)

      if (index === -1) {
        state.activeCategories.unshift(category)
        resetLastUpdated()
      }
    }

    const removeCategory = (category) => {
      const index = state.activeCategories
        .map((activeCategory) => activeCategory.slug)
        .indexOf(category.slug)
      if (index > -1) {
        state.activeCategories.splice(index, 1)
        resetLastUpdated()
      }
    }

    const removeAllCategories = () => {
      setActiveCategories(null)
    }

    const setTerms = (terms) => {
      state.terms = terms || []
      resetLastUpdated()
    }

    const addTerm = (term) => {
      if (state.terms.indexOf(term) != -1) {
        return
      }

      state.terms.push(term)
      resetLastUpdated()
    }

    const removeTerm = (term) => {
      const index = state.terms.indexOf(term)
      if (index > -1) {
        const tempArray = state.terms
        tempArray.splice(index, 1)
        setTerms(tempArray)
      }
    }

    const clearTermsAndCategories = () => {
      removeAllCategories(null)
      setTerms()
    }

    const removeTermsAndFilters = (term) => {
      if (term.type === 'filter') {
        removeCategory(term.name)
      }

      if (term.type === 'term') {
        removeTerm(term.name)
      }
    }

    const incrementPage = () => {
      state.page += 1
    }

    const resetPageNumber = () => {
      state.page = 1
    }

    return {
      searchQuery: state,
      activeCategories: computed(() => state.activeCategories),
      activeTerms: computed(() => state.terms),
      activeTermsAndFilters,
      language: computed(() => state.language),
      searchType: computed(() => state.searchType),
      groupByCategories,
      addCategory,
      removeCategory,
      removeAllCategories,
      setTerms,
      addTerm,
      removeTerm,
      clearTermsAndCategories,
      removeTermsAndFilters,
      setActiveCategories,
      setAllSearchTypes,
      setSearchType,
      setSorting,
      setView,
      incrementPage,
      resetPageNumber
    }
  }
}
